import { 
    Component,
    ViewChild
} from '@angular/core';

@Component({
  templateUrl: './bar.html'  
})
export class BarComponent { 

    constructor() {
        this.Bar =
        {
            Name: "Bar Name",
            Items: [
                { Name: "Item 1", Value: "Value 1"},
                { Name: "Item 2", Value: "Value 1"}
            ]
        }
    }

    public Bar;

    @ViewChild(BarComponent) BarControl: BarComponent;
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/bar/bar-component.ts